import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ActionButton from '../../../Components/Common/ActionButton';

const PreviewDocumentModal = ({ isOpen, toggle, document }) => {
  const fileName =
    document?.originalFileName || document?.fileName || 'Document';

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size='xl'>
      <ModalBody className='p-3 p-sm-4'>
        <div className='d-flex justify-content-between align-items-start mb-3'>
          <div style={{ minWidth: 0 }}>
            <h5 className='fw-bold mb-0'>Preview Deal Recap</h5>
            <small className='text-muted text-break'>{fileName}</small>
          </div>
          <button
            type='button'
            className='btn-close'
            onClick={toggle}
            aria-label='Close'
          ></button>
        </div>

        {document?.fileUrl ? (
          <iframe
            title='deal-recap-preview'
            src={document.fileUrl}
            className='w-100 border rounded'
            style={{ height: '70vh', minHeight: '320px' }}
          />
        ) : (
          <div className='border rounded text-center py-5'>
            <i
              className='ri-file-damage-line text-muted'
              style={{ fontSize: '3rem', opacity: 0.5 }}
            ></i>
            <p className='mt-2 mb-0 text-muted'>
              Document file is not available
            </p>
          </div>
        )}

        <div className='d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3'>
          {document?.fileUrl && (
            <ActionButton
              variant='secondary'
              icon='ri-external-link-line'
              href={document.fileUrl}
              target='_blank'
              rel='noreferrer'
              tag='a'
            >
              Open in new tab
            </ActionButton>
          )}
          <ActionButton
            variant='secondary'
            icon='ri-close-line'
            className='px-4'
            onClick={toggle}
          >
            Close
          </ActionButton>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PreviewDocumentModal;
